module.exports = __webpack_public_path__ + "img/profile_box_gray_use_reasons.bff21c3a.svg";